// extracted by mini-css-extract-plugin
export const wrapper = "navigation-module--wrapper--1sX58";
export const logo = "navigation-module--logo--3Yqkb";
export const logo_svg = "navigation-module--logo_svg--3TGlX";
export const links = "navigation-module--links--Srpsj";
export const link = "navigation-module--link--1N0wt";